import React, { useEffect, useState } from "react";
import Navbar from "../components/navbar/Navbar";
import Banner from "../components/banner/Banner";
import Footer from "../components/footer/Footer";
import "../components/cart/Cart.css" 
import Checkout from "../components/checkOut/CheckOut";

const CheckoutPage = () => {
    useEffect(() => {
      window.scrollTo(0, 0);
    }, []);
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    country: "France",
    streetAddress: "",
    apartment: "",
    city: "",
    zip: "",
    phone: "",
    email: "",
    createAccount: false,
    shipDifferent: false,
    paymentMethod: "bank",
    termsAccepted: false,
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Form Submitted", formData);
  };

  return (
  <div className="bg-imagea">
    <Navbar/>
<Banner title="Checkout"/>
<Checkout/>

    <Footer/>
    </div>
  );
};

export default CheckoutPage;
